import { render } from "./CourseCategoryEdit.vue?vue&type=template&id=e08274fa&scoped=true"
import script from "./CourseCategoryEdit.vue?vue&type=script&lang=js"
export * from "./CourseCategoryEdit.vue?vue&type=script&lang=js"

import "./CourseCategoryEdit.vue?vue&type=style&index=0&id=e08274fa&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08274fa"]])

export default __exports__